import { useMutation } from "react-query";
import { useParams } from "react-router-dom"
import shortLinkService from "../../service/reactQueryServices/services/shortLinkService";
import { useEffect } from "react";


const ShortLink = () => {
  const { mutateAsync: getShortLinkData, isLoading } = useMutation("getShortLinkData", shortLinkService.getShortLinkData);
  const params = useParams();

  const handleGetData = async () => {
    try {
      const response = await getShortLinkData(params.key || '')
      if (response?.data?.fullUrl) {
        window.location.href = response?.data?.fullUrl;
      }
    } catch (error) {

    }
  }

  useEffect(() => {
    handleGetData()
  }, [])

  return null
}



export default ShortLink
